function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 0a20 20 0 1020 20A20 20 0 0020 0zm0 38.25A18.25 18.25 0 1138.25 20 18.27 18.27 0 0120 38.25z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M31.28 7.78a.81.81 0 00-.81-.78h-3.73a.81.81 0 100 1.62h1.71l-2 2a7.75 7.75 0 00-12.62 5.55 7.76 7.76 0 001.78 15v1.15h-1.78a.81.81 0 000 1.62h1.79v1.53a.81.81 0 00.81.81.82.82 0 00.82-.81v-1.53H19a.81.81 0 100-1.62h-1.75v-1.15a7.78 7.78 0 006.93-7.25 7.62 7.62 0 002.89-1.81 7.77 7.77 0 00.54-10.38l2.06-2.06v1.93a.81.81 0 00.81.8.81.81 0 00.8-.82l-.06-3.66a.61.61 0 00.06-.14zm-15.5 9.82h.65a5.9 5.9 0 015.8 4.9 5.87 5.87 0 01-4.81-1.68 5.89 5.89 0 01-1.64-3.22zm.65 11.73A5.88 5.88 0 0114 18.12a7.68 7.68 0 002.12 4 7.79 7.79 0 005.5 2.27h.66a5.9 5.9 0 01-5.85 4.94zm9.31-8.55A6.18 6.18 0 0124.05 22a7.78 7.78 0 00-7.62-6.27h-.66a5.88 5.88 0 1110 5.07z"
});

function SvgGender(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "assets/images/gender.613e8655.svg";
export { SvgGender as ReactComponent };